import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import colors from '../../common/components/ui/colors';
import withLocalized from '../../localization/withLocalized';

const prosSelectorItemMargin = 20;

export const ProsSelectorContainer = styled.div`
  position: relative;
  display: flex;
  margin-bottom: ${(35 - prosSelectorItemMargin) / 16}rem;
  opacity: 1;
  flex-wrap: wrap;

  ${props => props.disabled ? 'opacity: .6;' : ''}
`;

export const ProsSelectorName = styled.span`
  font-size: ${16 / 16}rem;
  color: ${props => props.theme.GRAY_DARK};
`;

export const ProSelectorActiveBar = styled.span`
  display: block;
  height: ${9 / 16}rem;
  background-color: ${props => props.theme.GRAY_ULTRA_LIGHT};
  transition-property: background-color;
  transition-duration: 270ms;
  transition-timing-function: ease-out;
`;

export const ProsSelectorImage = styled.figure`
  width: ${32 / 16}rem;
  height: ${32 / 16}rem;
  margin-right: ${7 / 16}rem;
  border-radius: 500rem;
  background-color: ${props => props.theme.GRAY_LIGHTER};
  background-position: center;
  background-size: cover;
  border: ${1 / 16}rem solid ${props => props.theme.GRAY_LIGHTER};
`;

export const ProsSelectorItem = styled.a`
  transition-property: box-shadow;
  transition-duration: 170ms;
  transition-timing-function: ease-out;
  margin-right: ${prosSelectorItemMargin / 16}rem;
  margin-bottom: ${prosSelectorItemMargin / 16}rem;
  background: #FFFFFF;
  border: ${1 / 16}rem solid ${props => props.theme.GRAY_LIGHTER};
  box-shadow: 0 ${1 / 16}rem ${5 / 16}rem 0 rgba(155,155,155,0.37);
  border-radius: ${2.04 / 16}rem;
  overflow: hidden;
  cursor: default;
  
  &.selected {
    ${ProSelectorActiveBar} {
      background-color: ${props => props.theme.BRAND_GREEN};
    }
  }
  
  &:hover {
    :not([disabled]) {
      :not(.selected) {
        cursor: pointer;
        
        ${ProSelectorActiveBar} {
          background-color: ${props => props.theme.GRAY_SEMI};
        }
      }
    }
  }
  
  &:last-child {
    margin-right: 0;
  }
`;

export const ProSelectorItemContent = styled.span`
  display: flex;
  align-items: center;
  padding: ${14 / 16}rem ${13 / 16}rem;
`;

class ProSelector extends Component {

  render () {
    const {
      pros,
      disabled,
    } = this.props;

    return (
      <ThemeProvider theme={colors}>
        <ProsSelectorContainer disabled={disabled}>
          {pros.map(this._renderSelectorItem)}
        </ProsSelectorContainer>
      </ThemeProvider>
    );
  }

  _renderSelectorItem = (proSelect, idx) => {
    const {
      localized,
      pro,
      disabled,
    } = this.props;

    const prefix = `${localized('lesson_booking.calendar.teacher')}: `;
    return (
      <ProsSelectorItem
        key={idx}
        className={pro.id === proSelect.id ? 'selected' : ''}
        disabled={disabled}
        onClick={() => this._handleOnChange(idx)}
        title={`${prefix}${proSelect.display_name}`}
      >
        <ProSelectorItemContent>

          <ProsSelectorImage style={{backgroundImage: `url(${this._getProImage(proSelect.picture)})`}}/>
          <ProsSelectorName>
            {proSelect.display_name}
          </ProsSelectorName>

        </ProSelectorItemContent>
        <ProSelectorActiveBar/>

      </ProsSelectorItem>
    );
  }

  _handleOnChange = (idx) => {
    const {
      onChange,
      disabled,
    } = this.props;

    if (disabled) {
      return;
    }

    onChange({
      target: {
        value: idx,
      },
    });
  }

  _getProImage = (picture) => {
    if (picture && picture.length) {
      return picture[0].formatted_medium;
    }

    return '';
  }
}

ProSelector.propTypes = {
  disabled: PropTypes.bool,
  pros: PropTypes.array,
  pro: PropTypes.object,
  onChange: PropTypes.func,
};

export default withLocalized(ProSelector);


// WEBPACK FOOTER //
// ./src/modules/pros/components/ProSelector.js